document.addEventListener('click', async function(e){

  const plusBtn = e.target.closest('.cart-item .quantity__button[name="plus"]');
  const minusBtn = e.target.closest('.cart-item .quantity__button[name="minus"]');

  if(!plusBtn && !minusBtn) return;

  e.preventDefault();

  const wrapper = e.target.closest('quantity-input');

  if(!wrapper) return;

  const input = wrapper.querySelector('.quantity__input');

  if(!input) return;

  const line = input.dataset.index;

  let quantity = parseInt(input.value);

  if(plusBtn){
    quantity++;
  }

  if(minusBtn && quantity > 1){
    quantity--;
  }

  input.value = quantity;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  });

  location.reload();

});


/* ===== SWIPE GALERÍA PRODUCTO EN MÓVIL ===== */

(function () {

  if (window.__smartPrimeGallerySwipe) return;

  window.__smartPrimeGallerySwipe = true;

  function initGallerySwipe() {

    if (window.innerWidth >= 750) return;

    document.querySelectorAll('media-gallery .product__media-list').forEach(function (slider) {

      if (slider.dataset.swipeFixed === 'true') return;

      slider.dataset.swipeFixed = 'true';

      let startX = 0;
      let startY = 0;

      slider.addEventListener('touchstart', function (e) {

        if (!e.touches || !e.touches.length) return;

        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;

      }, { passive: true });


      slider.addEventListener('touchend', function (e) {

        if (!e.changedTouches || !e.changedTouches.length) return;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;

        const diffX = startX - endX;
        const diffY = startY - endY;

        // Ignorar movimientos principalmente verticales
        if (Math.abs(diffX) < 40 || Math.abs(diffX) <= Math.abs(diffY)) return;

        const slides = Array.from(
          slider.querySelectorAll('.product__media-item')
        );

        if (!slides.length) return;

        const currentScroll = slider.scrollLeft;

        let currentIndex = 0;
        let smallestDistance = Infinity;

        slides.forEach(function (slide, index) {

          const distance = Math.abs(slide.offsetLeft - currentScroll);

          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }

        });

        let newIndex = currentIndex + (diffX > 0 ? 1 : -1);

        if (newIndex < 0) {
          newIndex = 0;
        }

        if (newIndex > slides.length - 1) {
          newIndex = slides.length - 1;
        }

        slider.scrollTo({
          left: slides[newIndex].offsetLeft,
          behavior: 'smooth'
        });

      }, { passive: true });

    });

  }


  initGallerySwipe();


  document.addEventListener('shopify:section:load', function () {

    setTimeout(initGallerySwipe, 100);

  });


  window.addEventListener('resize', initGallerySwipe);

})();